import _ from 'lodash';
import { api } from '@breezeway/brzw-react-core';
import common from '@common';
import { getCurrentUser } from '../app/selectors';

const { RSAA } = api;
const {
  storage: { getCompanyId, getUserId },
  tokenUtils: { getAuthToken },
} = common.utils;

const authMiddleware = redux => next => action => {
  if (_.isUndefined(action) || _.isUndefined(action[RSAA])) {
    return next(action);
  }

  action[RSAA].headers['Breezeway-Platform'] = 'web';
  action[RSAA].headers['Breezeway-Version'] = process.env.PACKAGE_VERSION;

  let userId = getUserId();
  let companyId = getCompanyId();

  if (!userId || !companyId) {
    const state = redux.getState();
    const user = getCurrentUser(state);
    userId = userId || _.get(user, 'id');
    companyId = companyId || _.get(user, 'company_person.company_id');
  }

  if (userId) action[RSAA].headers.BreezewayUID = userId;
  if (companyId) action[RSAA].headers.BreezewayCID = companyId;

  if (_.has(action[RSAA].headers, 'tokenConfig')) {
    const token = getAuthToken(action[RSAA].headers.tokenConfig);
    action[RSAA].headers = _.omit(action[RSAA].headers, ['tokenConfig']);
    if (token) {
      action[RSAA].headers.Authorization = `JWT ${token}`;
    }
  }

  const taskToken = getAuthToken('task');
  if (taskToken) {
    action[RSAA].headers.TaskToken = taskToken;
  }

  return next(action);
};

export default authMiddleware;
